import { useCallback, useState } from "react";
import { BaseReportingModel } from "../@shared/Models/Reporting/BaseReportingModel";
import { ReportingResult } from "../@shared/Models/Reporting/ReportingResult";
import { ReportingWithIdModel } from "../@shared/Models/Reporting/ReportingWithIdModel";
import RespondClient from "../@shared/Models/RespondClient";

export type UseReportingProps = {
    onLoadData: (input: ReportingWithIdModel | BaseReportingModel) => Promise<RespondClient<ReportingResult>>
}

export type UseReportingResult = {
    onLoadDataset: (id: string) => void;
    onChangeFrom: (from: Date) => void;
    onChangeTo: (to: Date) => void;
    onChangeGranularity: (granularityInMinutes: number) => void;
    isLoadingDataset: boolean;
    dataResults: ReportingResult | null;
    baseRequest: BaseReportingModel;
}

export const useReporting = (props: UseReportingProps) => {
    const [isLoadingDataset, setIsLoadingDataset] = useState<boolean>(true);

    const [baseRequest, setBaseRequest] = useState<BaseReportingModel>({
        from: new Date(new Date().setDate(new Date().getDate() - 7)),
        to: new Date(),
        granularityInMinutes: 1440
    });
    const [dataResults, setDataResults] = useState<ReportingResult | null>(null);

    const onChangeFrom = useCallback((from: Date) => {
        setBaseRequest(prev => ({ ...prev, from }));
    }, []);

    const onChangeTo = useCallback((to: Date) => {
        setBaseRequest(prev => ({ ...prev, to }));
    }, []);

    const onChangeGranularity = useCallback((granularityInMinutes: number) => {
        setBaseRequest(prev => ({ ...prev, granularityInMinutes }));
    }, []);

    const onLoadDataset = useCallback(async (id: string) => {
        setIsLoadingDataset(true);
        const result = await props.onLoadData({ ...baseRequest, id });
        setDataResults(result.data);
        setIsLoadingDataset(false);
    }, [baseRequest, props]);

    return {
        onLoadDataset,
        onChangeFrom,
        onChangeTo,
        onChangeGranularity,
        dataResults,
        isLoadingDataset,
        baseRequest
    }
}